import React from 'react'
import PropTypes from 'prop-types'
// import { Link } from 'react-router-dom'


export default function Navbar(props) {
    return (
        <div>
            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
                <div className="container-fluid">
                    <a className="navbar-brand" href="#myBox"> {props.title} </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" href="#myBox">Home</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link" href="/about">{props.about}</a>
                            </li> */}
                            {/* <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" to="/" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Dropdown
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><a className="dropdown-item" to="/">Action</a></li>
                <li><a className="dropdown-item" to="/">Another action</a></li>
                <li><hr className="dropdown-divider"/></li>
                <li><a className="dropdown-item" to="/">Something else here</a></li>
              </ul>
            </li> */}
                            {/* <li className="nav-item">
              <a className="nav-link disabled">Disabled</a>
            </li> */}
                        </ul>
                        {/* <form className="d-flex">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">Search</button>
                        </form> */}

                        {/* <div className="form-check form-switch " > */}
                        {/* <div className="form-check form-switch text-light" > */}

                        <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'}`} >
                            <input className="form-check-input" onClick={props.toggleMode1} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
                        </div>

                        {/* <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'}`} >
                            <input className="form-check-input" onClick={props.toggleMode2} type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode 2</label>
                        </div> */}
                    </div>
                </div>
            </nav>

        </div>
    )
}

Navbar.prototype = {
    title: PropTypes.string.isRequired,
    about: PropTypes.string.isRequired
}

Navbar.defaultProps = {
    title: 'Please write title',
    about: 'About'
}
